/* eslint-disable comma-dangle */

export default {
  address: ['user-input', 'jk', 'map', 'underground'],
  'about-object': [
    'commercial-area-parts',
    'common/cadastral-number',
    'common/tax-number',
    'commercial-multi-area',
    'floor-commercial',
    'is-legal-address-provided',
    'ceiling-height',
    'is-occupied',
    'available-from',
    'layout',
    'common/water-pipes',
    'electricity-power',
    'condition-type',
    'has-furniture',
    {
      name: 'visual-divider',
      hideOnMobile: true,
    },
    'access-type',
    {
      name: 'visual-divider',
      hideOnMobile: true,
    },
    'parking',
    'common/parking-places-count',
    'common/parking-price-monthly',
  ],
  'about-building': [
    'name-and-year-commercial-autocomplete-no',
    'building-type',
    'commercial-class',
    'total-area',
    'land',
    {
      name: 'visual-divider',
      hideOnMobile: true,
    },
    'building-status-type',
    'building-developer',
    'building-management-company',
    'additional-items',
  ],
  'price-and-deal-terms': ['price-multi-sale', 'vat-type', 'lease-assignment-checkbox', 'agent-bonus'],
};
